module.exports = __webpack_public_path__ + "static/media/name.b60fc949.svg";